import React from 'react';

const MenuIcon = (props) => {
  return (
    <svg className={props.className} width="1em" height="1em" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.0001 15.7857C14.5386 15.7857 15.7858 14.5385 15.7858 13C15.7858 11.4615 14.5386 10.2143 13.0001 10.2143C11.4616 10.2143 10.2144 11.4615 10.2144 13C10.2144 14.5385 11.4616 15.7857 13.0001 15.7857Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.7501 15.3214C24.0322 15.3214 25.0716 14.2821 25.0716 13C25.0716 11.7179 24.0322 10.6786 22.7501 10.6786C21.468 10.6786 20.4287 11.7179 20.4287 13C20.4287 14.2821 21.468 15.3214 22.7501 15.3214Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3.25014 15.3214C4.53223 15.3214 5.57157 14.2821 5.57157 13C5.57157 11.7179 4.53223 10.6786 3.25014 10.6786C1.96805 10.6786 0.928711 11.7179 0.928711 13C0.928711 14.2821 1.96805 15.3214 3.25014 15.3214Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default MenuIcon;